import React from 'react';
import PropTypes from 'prop-types';

// Components
import { Button } from 'src/react/components/buttons';
import EmptyPage from 'src/react/recommendations/components/EmptyIdeaList/EmptyPage';

const StartOverExploreMore = (props) => {
  const { restartHandler, exploreMoreHandler, recommendationsSurveyPath } =
    props;
  return (
    <EmptyPage
      Header={() => (
        <h1 className="mb-2 font-normal text-gray-60 text-6 mb-5">
          <span className="block">That’s all of your recommendations</span>for
          now.
        </h1>
      )}
    >
      <Button
        data-testid="start_over_empty_recommendation_unlock_handler"
        className="flex-full select-none mb-1 sm:mb-0"
        size="large"
        onClick={restartHandler}
      >
        Start Over
      </Button>
      <Button
        data-testid="explore_more_empty_recommendation_unlock_handler"
        className="flex-full select-none ml-0 sm:ml-3"
        size="large"
        onClick={exploreMoreHandler}
        href={recommendationsSurveyPath}
        style="secondary"
      >
        Explore More
      </Button>
    </EmptyPage>
  );
};

StartOverExploreMore.propTypes = {
  exploreMoreHandler: PropTypes.func,
  restartHandler: PropTypes.func,
  recommendationsSurveyPath: PropTypes.string
};

export default StartOverExploreMore;
